<template>
  <div class="echoInfo">
    <div class="video flex_r_start">
      <div class="flex1">
        <div class="infotitle f28 line40 fw600">
          {{ infoData.title }}
        </div>
        <!-- <p class="fgray f16 line22 margint12">3392查看 2021-09-17 17:05:34</p> -->
      </div>
      <div v-if="infoData.author" class="publisher marginl16 flex0 flex_r">
        <img :src="infoData.author.logo" class="ava flex0" alt="" />
        <div class="marginl12 flex1">
          <p @click="goAuthor(infoData.author.id)" class="name f20 cursor line28 fw600">{{ infoData.author.name }}</p>
          <p class="fgray flex0 f16 line22">
            关注{{ infoData.author.fs }} {{ infoData.author.dz }}点赞
          </p>
        </div>
        <div
          @click="setFollow"
          :class="[infoData.author.is_follow > 0 && 'active']"
          class="followAuthor marginl4"
        >
          {{ infoData.author.is_follow > 0 ? "已关注" : "关注" }}
        </div>
      </div>
    </div>
    <div class="msg margint8 f18 fgray flex_r">
      <div class="time">{{ infoData.time }}</div>
      <!-- <div class="view marginl28 flex_r">
        <svgIcon name="eye" />
        <span class="marginl12">2223333</span>
      </div>
      <div class="message marginl28 flex_r">
        <svgIcon name="msg" />
        <span class="marginl12">111</span>
      </div> -->
    </div>
    <div v-html="infoData.content" class="main pt60"></div>
    <div class="subtitle f32 line44 fw600 pt60">发表评论</div>
    <textarea
      maxlength="200"
      class="viewpoint margint20 f20 lien28"
      v-model="content"
      placeholder="您可以在此发表自己的看法与见解，请文明发言"
    ></textarea>
    <div @click="subComment" class="sub f16 margint20">发表评论</div>
    <div class="subtitle f32 line44 fw600 pt60">全部评论</div>
    <div v-if="infoData.replys && infoData.replys.length" class="list">
      <div v-for="(v, k) in infoData.replys" :key="k" class="item">
        <div class="author flex_r">
          <img :src="v.logo" alt="" class="ava" />
          <div class="msg">
            <p class="nama f20 line28 fw600">{{ v.name }}</p>
            <p class="time f16 line22">{{ v.time }}</p>
          </div>
        </div>
        <div class="content f20 line36 margint20">
          {{ v.content }}
        </div>
      </div>
    </div>
    <div v-show="showFollow" class="mask flex_c_center">
      <div class="content flex_c_start">
        <el-radio
          v-model="check"
          v-for="(item, index) in myFollowDoc"
          :key="index"
          :label="item.id"
          border
          >{{ item.name }}</el-radio
        >
        <el-input
          v-model="input"
          maxlength="10"
          @input="changeInput"
          placeholder="添加到新的列表"
        ></el-input>
        <div class="margint20 btn">
          <el-button size="medium" @click.native="setDoc" type="primary"
            >确定</el-button
          >
        </div>
      </div>
      <div @click.stop="showFollow = !showFollow" class="close margint40">
        <svgIcon class="f40" name="close" />
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
export default {
  name: "echoInfo",
  props: ["id"],
  data() {
    return {
      uid: "",
      infoData: {},
      content: "",
      showFollow: false,
      input: "",
      myFollowDoc: [],
      check: 0,
    };
  },
  mounted() {
    this.getUserInfo().then((res) => {
      this.uid = res.uid;
      this.getInfo();
      this.getFollowDoc();
    });
  },
  methods: {
    ...mapActions(["getUserInfo"]),
    goAuthor(uid){
      this.$router.push({
        name: 'myindex',
        params: {
          uid
        }
      })
    },
    async getFollowDoc() {
      let data = await this.$http.get(this.$api.getFollowDoc, {
        params: { uid: this.uid },
      });
      this.myFollowDoc = data.data;
    },
    changeInput() {
      this.check = -1;
    },
    async setDoc() {
      if (!this.$isLogin()) return;
      if (this.check || this.check == 0) {
        let data = await this.$http.get(this.$api.setFollow, {
          params: {
            uid: this.uid,
            id: this.infoData.author.id,
            sdid: this.check, //文件夹id
          },
        });
        this.getInfo();
        this.$message.success(data.msg);
      } else {
        if (!this.input) return this.$alert("请选择添加列表");
        this.$http
          .get(this.$api["createFollowDoc"], {
            params: {
              uid: this.uid,
              name: this.input,
            },
          })
          .then(async (res) => {
            let data = await this.$http.get(this.$api.setFollow, {
              params: {
                uid: this.uid,
                id: this.id,
                sdid: res.data, //文件夹id
              },
            });
            this.$message.success(data.msg);
            this.getInfo();
          });
      }
      this.showFollow = !this.showFollow;
    },
    async setFollow() {
      if (!this.$isLogin()) return;
      if (this.infoData.author.is_follow > 0) {
         let data = await this.$http.get(this.$api.setFollow, {
              params: {
                uid: this.uid,
                id: this.infoData.author.id,
                sdid: this.infoData.author.is_follow, //文件夹id
              },
            });
            this.getInfo();
            this.$message.success(data.msg);
            return
      }
      if (!this.myFollowDoc[0]) {
        this.getFollowDoc();
      }
      this.showFollow = !this.showFollow;
    },
    async getInfo() {
      let data = await this.$http.get(this.$api.tzInfo, {
        params: { id: this.id, uid: this.uid },
      });
      this.infoData = data.data;
    },
    async subComment() {
      try {
        if (!this.$isLogin()) return;
        if (!this.content) return this.$message.error("请输入评论内容");
        let data = await this.$http.post(this.$api.addReply, {
          uid: this.uid,
          eid: this.id,
          content: this.content,
        });
        this.$message.success(data.msg);
        this.content = "";
        this.getInfo();
      } catch (e) {
        throw new Error({});
      }
    },
  },
};
</script>
<style lang="less" scoped>
.mask {
  .content {
    background: white;
    padding: 40px 60px;
  }
}
/deep/ .el-radio.is-bordered {
  margin-bottom: 10px;
}
/deep/ .el-radio.is-bordered + .el-radio.is-bordered {
  margin-left: 0;
}

.btn {
  width: 100%;
}
/deep/ .el-button {
  width: 100%;
  border-color: #ad2729;
  background: #ad2729;
}
.video {
  width: 100%;
  .infotitle {
    width: 824px;
    word-break: break-all;
    word-wrap: break-word;
    overflow: hidden;
  }
  .publisher {
    width: 344px;
    height: 74px;
    padding: 0 16px;
    box-sizing: border-box;
    background: #fafafa;
    .name:hover{
        color: #ad2729;
      }
    .ava {
      width: 52px;
      height: 52px;
      border-radius: 50%;
    }
    .followAuthor {
      width: 70px;
      height: 36px;
      color: white;
      text-align: center;
      line-height: 36px;
      background: #ad2729;
      &.active {
        background: rgba(173, 39, 41, 0.3);
      }
    }
  }
}
.viewpoint {
  padding: 12px;
  width: 1184px;
  height: 174px;
  border-radius: 4px;
  border: 1px solid #958f8f;
  box-sizing: border-box;
}
.sub {
  height: 36px;
  width: fit-content;
  text-align: center;
  color: white;
  line-height: 36px;
  padding: 0 20px;
  background: #ad2729;
}
.list {
  margin-top: 16px;
  .item {
    width: 1184px;
    padding: 40px;
    border-bottom: 2px solid #fafafa;
    img {
      width: 60px;
      height: 60px;
      border-radius: 50%;
    }
    .msg {
      margin-left: 16px;
    }
  }
}
</style>